"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThemer = exports.ThemerProvider = exports.isScheme = exports.ThemeContext = exports.prefersDark = void 0;
var react_1 = __importStar(require("react"));
var theme_1 = require("../theme");
var isServerSide = typeof window === "undefined";
var prefersDark = function () {
    return (!isServerSide &&
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches);
};
exports.prefersDark = prefersDark;
var KEY = "auspices.eos.scheme";
var DEFAULT_SCHEME = "light";
var DEFAULT_BACKEND = {
    get: function () {
        if (isServerSide)
            return null;
        var saved = localStorage.getItem(KEY);
        return (0, exports.isScheme)(saved) ? saved : null;
    },
    set: function (scheme) {
        if (isServerSide)
            return;
        localStorage.setItem(KEY, scheme);
    },
};
exports.ThemeContext = (0, react_1.createContext)({
    key: KEY,
    theme: theme_1.THEME,
    scheme: DEFAULT_SCHEME,
    setScheme: function () { },
    toggleScheme: function () { },
});
var isScheme = function (value) {
    return !!value && Object.keys(theme_1.SCHEMES).includes(value);
};
exports.isScheme = isScheme;
var ThemerProvider = function (_a) {
    var children = _a.children, _b = _a.initialScheme, initialScheme = _b === void 0 ? DEFAULT_SCHEME : _b, _c = _a.backend, backend = _c === void 0 ? DEFAULT_BACKEND : _c;
    var _d = __read((0, react_1.useState)(initialScheme), 2), scheme = _d[0], setScheme = _d[1];
    (0, react_1.useEffect)(function () {
        var _a;
        setScheme((_a = backend.get()) !== null && _a !== void 0 ? _a : initialScheme);
    }, [backend, initialScheme]);
    var theme = (0, react_1.useMemo)(function () { return (__assign(__assign({}, theme_1.THEME), { scheme: scheme, colors: theme_1.SCHEMES[scheme] })); }, [scheme]);
    var toggleScheme = (0, react_1.useCallback)(function () { return setScheme(function (prevScheme) { return (prevScheme === "dark" ? "light" : "dark"); }); }, []);
    (0, react_1.useEffect)(function () { return backend.set(scheme); }, [backend, scheme]);
    return (react_1.default.createElement(exports.ThemeContext.Provider, { value: { theme: theme, scheme: scheme, setScheme: setScheme, toggleScheme: toggleScheme } }, children));
};
exports.ThemerProvider = ThemerProvider;
var useThemer = function () {
    var _a = (0, react_1.useContext)(exports.ThemeContext), theme = _a.theme, scheme = _a.scheme, setScheme = _a.setScheme, toggleScheme = _a.toggleScheme;
    return { theme: theme, scheme: scheme, setScheme: setScheme, toggleScheme: toggleScheme };
};
exports.useThemer = useThemer;
//# sourceMappingURL=useThemer.js.map